import type { OffEmailsDirProps } from './model';
import EmailsDirProvider from './context/EmailsDirProvider';
import EmailsDirPanel from './EmailsDirPanel';

const OffEmailsDir = (props: OffEmailsDirProps) => (
    <EmailsDirProvider {...props}>
        <EmailsDirPanel show={props.show} />
    </EmailsDirProvider>
);

export default OffEmailsDir;
